// extracted by mini-css-extract-plugin
export var logo = "_9m-2";
export var logoWrapper = "_9m-1";
export var strip = "_9m-0";